import React, {Component, PropTypes} from 'react'
import {findDOMNode} from 'react-dom'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Nav, NavItem, PageHeader, Popover, Overlay} from 'react-bootstrap'
import {linkFinder} from '../../core/links'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import UpdatePatrimonyContactIdentityPopover from './UpdatePatrimonyContactIdentityPopover'
import RemoveLinkFromPatrimonyContactPopover from './RemoveLinkFromPatrimonyContactPopover'
import AddRemoveContactPopover from './AddRemoveContactPopover'
import style from './ContactDetail.less'

class ContactDetail extends Component {
    static propTypes = {
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    _openPopover(event, name) {
        event.preventDefault()
        this.setState({openedPopover: name})
    }

    _closePopover(event) {
        if (event) {
            event.preventDefault()
        }
        
        this.setState({openedPopover: null})
    }

    render() {
        const {children, dispatch, location, contact} = this.props
        const {openedPopover} = this.state
        const {editButton, editContainer} = this.refs

        const editMenuPopover = (
            <Popover>
                <ul className={style.menu}>
                    {contact._links.find(linkFinder('RemoveLinkFromPatrimonyContact')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'RemoveLinkFromPatrimonyContactPopover')}>
                                <span>> {i18n.unlinkPatrimonyContact}</span>
                            </a>
                        </li>
                    )}
                    {contact._links.find(linkFinder(['AddContact', 'RemoveContact'])) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'AddRemoveContactPopover')}>
                                <span>> {i18n.contacts}</span>
                            </a>
                        </li>
                    )}
                    {contact._links.find(linkFinder('UpdatePatrimonyContactIdentity')) && (
                        <li>
                            <a
                                href=''
                                onClick={(e) => this._openPopover(e, 'UpdatePatrimonyContactIdentityPopover')}>
                                <span>> {i18n.updatePatrimonyContact}</span>
                            </a>
                        </li>
                    )}
                </ul>
            </Popover>
        )

        const editOverlay = (name, popover) => (
            <Overlay rootClose
                target={() => findDOMNode(editButton)}
                placement='bottom'
                show={openedPopover == name}
                container={editContainer}
                onHide={() => this._closePopover()}>
                {popover}
            </Overlay>
        )

        return (
            <div className={style.default}>
                <div className={style.defaultContent}>
                    <PageHeader className='large'>
                        <div
                            ref='editContainer'
                            className={style.header}>
                            <span>{contact.name.firstName} {contact.name.lastName} {contact.name.value}</span>
                            <a
                                className={style.edit}
                                ref='editButton'
                                href=''
                                onClick={(e) => this._openPopover(e, 'EditMenuPopover')}
                                onMouseOver={(e) => this._openPopover(e, 'EditMenuPopover')}>
                                <Icon
                                    icon='gear'
                                    size='xs'
                                    active={openedPopover != null} />
                            </a>
                        </div>
                        {editOverlay('EditMenuPopover', editMenuPopover)}
                        {contact._links.find(linkFinder('RemoveLinkFromPatrimonyContact')) && editOverlay('RemoveLinkFromPatrimonyContactPopover', (
                            <RemoveLinkFromPatrimonyContactPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {contact._links.find(linkFinder(['AddContact', 'RemoveContact'])) && editOverlay('AddRemoveContactPopover', (
                            <AddRemoveContactPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                        {contact._links.find(linkFinder('UpdatePatrimonyContactIdentity')) && editOverlay('UpdatePatrimonyContactIdentityPopover', (
                            <UpdatePatrimonyContactIdentityPopover
                                onHide={(e) => this._closePopover(e)} />
                        ))}
                    </PageHeader>
                    <Nav justified
                        bsStyle='list'>
                        <NavItem
                            active={location.pathname.match(/\/patrimonycontacts\/[\w-]+$/) != null}
                            onClick={() => dispatch(push('/patrimonycontacts/' + contact.uid))}>
                            {i18n.synthesis}
                        </NavItem>
                        <NavItem disabled>
                            {i18n.tickets}
                        </NavItem>
                        <NavItem disabled>
                            {i18n.lots}
                        </NavItem>
                        <NavItem disabled>
                            {i18n.documents}
                        </NavItem>
                    </Nav>
                </div>
                {children}
            </div>
        )
    }
}

ContactDetail = connect((state) => ({
    location: state.router.location,
    contact: state.patrimony.contact.contact
}))(ContactDetail)

export default ContactDetail


// WEBPACK FOOTER //
// ./lib/patrimony/components/ContactDetail.js